const DeleteUserData = {
  unsetPreferences: {
    value: false,
    type: "checkbox",
    name: "unsetPreferences",
    id: "unsetPreferences",
    errorMsg: "",
    validation: {
      checkbox: true
    },
    checkButton: true
  },
  deleteUser: {
    value: false,
    type: "checkbox",
    name: "deleteUser",
    id: "deleteUser",
    noIteration: true,
    errorMsg: "",
    validation: {
      checkbox: true
    },
    checkButton: true
  }
};

export default DeleteUserData;
